import Store from "App/Store.js";

export default uuids => Store.dispatch({type: "basketRemove", uuids});
